<template>
  <div>
    <index-card fluid>
      <template slot="header">
        

        <v-row>
          <v-col class="white--text d-flex justify-space-between align-center headline">
            <div>
              <v-btn icon color="blue-grey darken-1" :to="{name: 'Home'}"><v-icon color="white">mdi-arrow-left</v-icon></v-btn>
            </div>
            <span>Consolidações Periódicas</span>
            <div class="d-flex">
              <v-icon color="white" @click="getData()">mdi-refresh</v-icon>
            </div>
          </v-col>
        </v-row>


      </template>
      <template slot="subheader">
        <div class="periodic-consolidations-filters">
          <filter-data
            :extra-filters-count="2"
            with_text_search
            :with_client="false"
            :with_date_start="false"
            :with_date_end="false"
            @doneFilter="handleDoneFilter"
          >
            <template v-slot:extra-filters>
              <v-col cols="12" md="6">
                <v-select
                  :items="periods"
                  v-model="period_filter"
                  item-text="period_show"
                  return-object
                  label="Período"
                  outlined
                  dense
                  hide-details="auto"
                  prepend-inner-icon="mdi-calendar-range"
                />
              </v-col>
              <v-col cols="12" md="6">
                <v-select
                  :items="consistency_options"
                  v-model="filter"
                  item-text="text"
                  item-value="value"
                  label="Consistência"
                  outlined
                  dense
                  hide-details="auto"
                  prepend-inner-icon="mdi-filter"
                />
              </v-col>
            </template>
          </filter-data>
        </div>
      </template>

      <template slot="data_table">
        <v-card>
          <v-card-text>

            <v-data-table v-if="!loading_all" :headers="headers" :items="filtered_consolidations" class="elevation-0" :search="tableSearch">
              <template v-slot:item.checks_custody.success="{item}">
                <v-icon :color="success_icon_map[item.checks_custody.success].color">
                    {{ success_icon_map[item.checks_custody.success].icon }}
                  </v-icon>
              </template>
              <template v-slot:item.payments.success="{item}">
                <v-icon :color="success_icon_map[item.payments.success].color">
                    {{ success_icon_map[item.payments.success].icon }}
                  </v-icon>
              </template>
              <template v-slot:item.trans_generation.success="{item}">
                <v-icon :color="success_icon_map[item.trans_generation.success].color">
                    {{ success_icon_map[item.trans_generation.success].icon }}
                  </v-icon>
              </template>
              <template v-slot:item.client_owes.success="{item}">
                <v-icon :color="success_icon_map[item.client_owes.success].color">
                    {{ success_icon_map[item.client_owes.success].icon }}
                  </v-icon>
              </template>
              <template v-slot:item.credit.success="{item}">
                <v-icon :color="success_icon_map[item.credit.success].color">
                    {{ success_icon_map[item.credit.success].icon }}
                  </v-icon>
              </template>
              <template v-slot:item.start_date="{item}">
                {{
                  $moment(item.start_date.split('T')[0] + 'T12:00:00').format('DD/MM')
                }}
                  ~ {{ $moment(item.end_date.split('T')[0] + 'T12:00:00').format('DD/MM') }}
              </template>
              <template v-slot:item.action="{item}">
                <v-btn text small color="primary" @click="()=>{show_id = item.id}">
                  <v-icon left>mdi-plus</v-icon>
                  detalhes
                </v-btn> 
              </template>
              <template v-slot:no-results>
                <v-alert  :value="true" type="error" icon="mdi-warning">
                  Não foi possível encontrar "{{ tableSearch }}".
                </v-alert>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
        <!--   :footer-props="{itemsPerPageOptions: [25, 50, 100, { 'text': 'Tds', 'value': -1 }]}" -->
        <v-card height="40vh" class="d-flex align-center"  v-if="loading_all">
          <v-card-text class="d-flex justify-center">
            <div class="d-flex flex-column align-center title">
              <span class="mb-2">Carregando...</span>
              <v-progress-circular  indeterminate color="blue-grey darken-1" size="50"></v-progress-circular>
            </div>
          </v-card-text>
        </v-card>
      </template>


    </index-card>

    <one-consolidation-details v-if="show_id" :consolidation_id="show_id"
      @close='handleCloseDetails'
    ></one-consolidation-details>

  </div>
</template>

<script>
import Api from '@/api/index'

export default {
  name: 'ClientPeriodicConsolidations',
  components: {
    OneConsolidationDetails: () => import('@/_backoffice/_financial/components/consolidation/OneConsolidationDetails.vue'),
    IndexCard: () => import("@/_backoffice/_registrations/components/shared/index/IndexCard.vue"),
    FilterData: () => import("@/components/shared/FilterData.vue"),
  },
  data() {
    return {
      filter: null,
      loading: {
        periods: false,
        consolidations: false,
      },
      local_filter: {},

      success_icon_map: {
        'false': { color: 'error', icon: 'mdi-thumb-down' },
        'true': { color: 'success', icon: 'mdi-thumb-up' },
      },

      periods: [],
      period_filter: null,
      consolidations: [],
      consistency_options: [
        { text: 'Todos', value: null },
        { text: 'Inconformes', value: 'false' },
        { text: 'Corretos', value: 'true' },
      ],

      headers: [
        { text: 'Nome do cliente', value: 'client_name', align: 'center' },
        { text: 'Cheques em custodia', value: 'checks_custody.success', align: 'center' },
        { text: 'Pagamentos', value: 'payments.success', align: 'center' },
        { text: 'Geração de faturas', value: 'trans_generation.success', align: 'center' },
        { text: 'Quanto o cliente deve', value: 'client_owes.success', align: 'center' },
        { text: 'Credito do cliente', value: 'credit.success', align: 'center' },
        { text: 'Período', value: 'start_date', align: 'center' },

        { text: 'Ação ', value: 'action', align: 'center' },
      ],

      show_id: null,
    }
  },
  computed: {
    tableSearch() {
      return (this.local_filter && this.local_filter.query) ? String(this.local_filter.query) : ''
    },
    loading_all(){
      return this.loading.periods || this.loading.consolidations
    },
    filtered_consolidations() {
      if (this.consolidations.length) {
        if (!this.filter) {
          return this.consolidations
        }
        let filter_fn = () => { }

        if (this.filter == 'false') {
          filter_fn = (c) => (
            c.checks_custody.success == false ||
            c.payments.success == false ||
            c.trans_generation.success == false ||
            c.client_owes.success == false ||
            c.credit.success == false
          )
        } else if (this.filter == 'true') {
          filter_fn = (c) => (
            c.checks_custody.success &&
            c.payments.success &&
            c.trans_generation.success &&
            c.client_owes.success &&
            c.credit.success
          )
        }
        return this.consolidations.filter(filter_fn)
      }
      return []
    },
  },
  methods: {
    handleDoneFilter(filter){
      this.local_filter = { ...filter }
    },
    getData(){
      this.getPeriods()
    },
    handleCloseDetails() {
      this.show_id = null
    },
    getPeriods() {
      this.loading.periods = true
      this.periods = []
      Api.Client.indexPeriodicConsolidation({ level: 'true' }).then(r => r.data).then(r => {
        r = r.data ? r.data.map(d => d.attributes) : r

        this.periods = [...r]
        this.period_filter = this.periods.slice(-1)[0]

      }).catch(err => {
        console.log(err);
      }).finally(()=>{
        this.loading.periods = false
      })
    },
    getConsolidations(filters) {
      this.loading.consolidations = true
      this.consolidation = {}
      Api.Client.indexPeriodicConsolidation(filters).then(r => r.data).then(r => {
        r = r.data ? r.data.map(d => d.attributes) : r
        r = r.map(d => {
          let { json_attributes, ...data } = d
          return { ...data, ...json_attributes }
        })

        this.consolidations = [...r]
      }).catch(err => {
        console.log(err);
      }).finally(() => {
        this.loading.consolidations = false
      })
    },
  },
  mounted() {
    this.getPeriods()
  },
  watch: {
    period_filter(nv, ov) {
      if (nv) {
        let { start_date, end_date } = nv
        let filter = { start_date, end_date, }
        this.getConsolidations(filter)
      }
    }
  },
}

</script>

<style scoped>
.periodic-consolidations-filters {
  width: 100%;
  flex: 1 1 100%;
  min-width: 0;
}
.periodic-consolidations-filters >>> .filter-data-card {
  width: 100%;
}
</style>
